import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CookieConsent } from '../../services/cookie-consent';

@Component({
  selector: 'app-cookie-banner',
  imports: [RouterLink],
  templateUrl: './cookie-banner.html',
  styleUrl: './cookie-banner.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieBanner {
  private readonly consent = inject(CookieConsent);

  protected readonly isOpen = this.consent.needsDecision;

  protected accept(): void {
    this.consent.accept();
  }

  protected reject(): void {
    this.consent.reject();
  }
}
